module.exports = __webpack_public_path__ + "static/media/snoo.d43ab901.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/snoo.png
// module id = 683
// module chunks = 0